import { render, staticRenderFns } from "./Territory.vue?vue&type=template&id=6e34ce6a&scoped=true"
import script from "./Territory.vue?vue&type=script&lang=js"
export * from "./Territory.vue?vue&type=script&lang=js"
import style0 from "./Territory.vue?vue&type=style&index=0&id=6e34ce6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e34ce6a",
  null
  
)

export default component.exports